import React, { useState } from 'react';
import footerLogo from '@iso/assets/images/localeats/footer-logo/footerLogo.svg';
import restoFooterLogo from '@iso/assets/images/localeats/footer-logo/restoFooterLogo.svg';
import FooterWrapper from './Footer.styles';
import IntlMessages from '@iso/components/utility/intlMessages';
import siteConfig from '@iso/config/site.config';
import facebook from '@iso/assets/images/socials/facebook.png';
import whatsUp from '@iso/assets/images/socials/whatsup.png';
import tikTok from '@iso/assets/images/socials/tiktok.png';
import instagram from '@iso/assets/images/socials/instagram.png';
import youtube from '@iso/assets/images/socials/youtube.png';
import twitter from '@iso/assets/images/socials/twitter.png';
import { useSelector } from 'react-redux';

const Footer = ({ marketplace }) => {
  console.log('marketplace footer', marketplace);
  const { language } = useSelector((state) => state.LanguageSwitcher);
  const socialsData = [
    // { name: 'facebook', path: 'https://www.facebook.com/', img: facebook },
    // { name: "whats'up", path: 'https://www.whatsapp.com/', img: whatsUp },
    // { name: 'tik-tok', path: 'https://www.tiktok.com/', img: tikTok },
    // { name: 'youtube', path: 'https://www.youtube.com/', img: youtube },
    {
      name: 'instagram',
      path: 'https://instagram.com/localbytesco',
      img: instagram,
    },
    { name: 'twitter', path: 'https://twitter.com/localbytesco', img: twitter },
  ];
  return (
    <FooterWrapper>
      <div className="footer">
        <div className="custom-container">
          <div className="footer-logo">
            <div className="logo-block">
              <p>Powered by</p>
              <img
                src={restoFooterLogo}
                alt="Footer Logo"
                className="resto-footer-img"
              />
            </div>

            <div className="page-policy-block">
              {language.languageId === 'russian' ? (
                <>
                  <p>
                    <a
                      href="https://orderbyte.io/api/v1/download/documents/user_aggrement_lb_ru.pdf"
                      className="policy-link"
                    >
                      <IntlMessages id="footer.UserAgreement" />
                    </a>
                  </p>
                  <p>
                    <a
                      href="https://orderbyte.io/api/v1/download/documents/privacy_policy_lb_ru.pdf"
                      className="policy-link"
                    >
                      <IntlMessages id="footer.PrivacyPolicy" />
                    </a>
                  </p>
                </>
              ) : language.languageId !== 'russian' ? (
                <>
                  <p>
                    <a
                      href="https://restogpt.ai/term-and-condition"
                      className="policy-link"
                    >
                      <IntlMessages id="footer.UserAgreement" />
                    </a>
                  </p>
                  <p>
                    <a
                      href="https://restogpt.ai/privacy-policy"
                      className="policy-link"
                    >
                      <IntlMessages id="footer.PrivacyPolicy" />
                    </a>
                  </p>
                </>
              ) : (
                ''
              )}
            </div>

            {/*<p>*/}
            {/*  <a href="" className="policy-link">*/}
            {/*    <IntlMessages id="footer.Help" />*/}
            {/*  </a>*/}
            {/*  &nbsp;&nbsp;&nbsp;&nbsp;*/}
            {/*  <a href="" className="policy-link">*/}
            {/*    FAQ*/}
            {/*  </a>*/}
            {/*</p>*/}
            <div className="copyright-block">
              <p className="copyright">{siteConfig.footerTextResto}</p>
              {/* {marketplace === 'lacanada' ? (
                <p className="copyright">{siteConfig.footerTextResto}</p>
              ) : (
                <p className="copyright">{siteConfig.footerText}</p>
              )}
              {marketplace === 'lacanada' ? null : (
                <div className="socials-block">
                  {socialsData.map(({ name, path, img }) => (
                    <a key={name} href={path} target="_blank">
                      <img src={img} alt={name} />
                    </a>
                  ))}
                </div>
              )} */}
            </div>
          </div>
        </div>
      </div>
    </FooterWrapper>
  );
};

export default Footer;
